import { AnimatedBadge } from '@frontend/components';
import { theme } from '@frontend/theme';
import { useCareCreditTranslations } from '../hooks/use-care-credit-translations';

export const CareCreditBetaChip = () => {
  const { t } = useCareCreditTranslations();

  return (
    <AnimatedBadge
      label={t('Beta')}
      animated={false}
      bgColor={theme.colors.indigo50}
      highlightColor={theme.colors.indigo20}
    />
  );
};
